var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.421875C17.3137 0.421875 20 3.10817 20 6.42188V14.4219C20 17.7356 17.3137 20.4219 14 20.4219H6C2.68629 20.4219 1.28855e-07 17.7356 0 14.4219V6.42188C1.28855e-07 3.10817 2.68629 0.421875 6 0.421875H14ZM13.6416 11.8213C11.6304 13.8321 8.36945 13.8323 6.3584 11.8213L5.15723 13.0234C7.83221 15.6979 12.1688 15.6979 14.8438 13.0234L13.6416 11.8213ZM6.5 6.42188C6.08333 6.42188 5.72917 6.56771 5.4375 6.85938C5.14583 7.15104 5 7.50521 5 7.92188C5 8.33854 5.14583 8.69271 5.4375 8.98438C5.72917 9.27604 6.08333 9.42188 6.5 9.42188C6.91667 9.42188 7.27083 9.27604 7.5625 8.98438C7.85417 8.69271 8 8.33854 8 7.92188C8 7.50521 7.85417 7.15104 7.5625 6.85938C7.27083 6.56771 6.91667 6.42188 6.5 6.42188ZM13.5 6.42188C13.0833 6.42188 12.7292 6.56771 12.4375 6.85938C12.1458 7.15104 12 7.50521 12 7.92188C12 8.33854 12.1458 8.69271 12.4375 8.98438C12.7292 9.27604 13.0833 9.42188 13.5 9.42188C13.9167 9.42188 14.2708 9.27604 14.5625 8.98438C14.8542 8.69271 15 8.33854 15 7.92188C15 7.50521 14.8542 7.15104 14.5625 6.85938C14.2708 6.56771 13.9167 6.42188 13.5 6.42188Z",
    fill: "#75C209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVery);
export default __webpack_public_path__ + "static/media/very.e160e7618260dc5f99c50182f80c3f72.svg";
export { ForwardRef as ReactComponent };